import { useState } from 'react';

export default function useDataStoreState({ generalData }) {
    const [dataStore, setDataStore] = useState({
        email: {
            se: {
                from_address: generalData?.email?.se?.from_address || '',
                from_name: generalData?.email?.se?.from_name || '',
                reply_to: generalData?.email?.se?.reply_to || '',
                full_address: generalData?.email?.se?.full_address || '',
            },
            no: {
                from_address: generalData?.email?.no?.from_address || '',
                from_name: generalData?.email?.no?.from_name || '',
                reply_to: generalData?.email?.no?.reply_to || '',
                full_address: generalData?.email?.no?.full_address || '',
            },
            fi: {
                from_address: generalData?.email?.fi?.from_address || '',
                from_name: generalData?.email?.fi?.from_name || '',
                reply_to: generalData?.email?.fi?.reply_to || '',
                full_address: generalData?.email?.fi?.full_address || '',
            },
            dk: {
                from_address: generalData?.email?.dk?.from_address || '',
                from_name: generalData?.email?.dk?.from_name || '',
                reply_to: generalData?.email?.dk?.reply_to || '',
                full_address: generalData?.email?.dk?.full_address || '',
            },
            is: {
                from_address: generalData?.email?.is?.from_address || '',
                from_name: generalData?.email?.is?.from_name || '',
                reply_to: generalData?.email?.is?.reply_to || '',
                full_address: generalData?.email?.is?.full_address || '',
            },
        },
        sms: {
            se: {
                current_sender: generalData?.sms?.se?.current_sender || '',
            },
            no: {
                current_sender: generalData?.sms?.no?.current_sender || '',
            },
            fi: {
                current_sender: generalData?.sms?.fi?.current_sender || '',
            },
            dk: {
                current_sender: generalData?.sms?.dk?.current_sender || '',
            },
            is: {
                current_sender: generalData?.sms?.is?.current_sender || '',
            },
        },
    });

    return [dataStore, setDataStore];
}
